var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "mt-5"
  }, [_c('b-container', {
    staticClass: "bv-example-row bv-example-row-flex-cols"
  }, [_c('b-row', {
    staticClass: "justify-content-md-center textCentred"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align-v": "center"
    }
  }, [_c('h1', [_vm._v("PHOTOGRAPHY SERVICES")])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "text-center d-flex d-none"
  }, _vm._l((_vm.items), function(item) {
    return _c('b-col', {
      key: item.id,
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "6",
        "lg": "6",
        "xl": "3",
        "align-v": "center"
      }
    }, [_c('div', {
      staticClass: "card-container"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "side"
    }, [_c('img', {
      directives: [{
        name: "img",
        rawName: "v-img:my-group",
        arg: "my-group"
      }],
      staticClass: "galleryItem",
      attrs: {
        "src": item.image,
        "alt": item.alt
      }
    })])])])])
  })), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "textLeft"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")]), _vm._v(" "), _c('p', {
    staticClass: "textLeft"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")])])], 1)], 1), _vm._v(" "), _c('b-container', {
    staticClass: "bv-example-row bv-example-row-flex-cols"
  }, [_c('b-row', {
    staticClass: "justify-content-md-center textCentred"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align-v": "center"
    }
  }, [_c('h1', [_vm._v("WEDDING PHOTOGRAPHY")])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "text-center d-flex d-none"
  }, _vm._l((_vm.items2), function(item) {
    return _c('b-col', {
      key: item.id,
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "6",
        "lg": "6",
        "xl": "3",
        "align-v": "center"
      }
    }, [_c('div', {
      staticClass: "card-container"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "side"
    }, [_c('img', {
      directives: [{
        name: "img",
        rawName: "v-img:my-group",
        arg: "my-group"
      }],
      staticClass: "galleryItem",
      attrs: {
        "src": item.image,
        "alt": item.alt
      }
    })])])])])
  })), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "textLeft"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")]), _vm._v(" "), _c('p', {
    staticClass: "textLeft"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")])])], 1)], 1), _vm._v(" "), _c('b-container', {
    staticClass: "bv-example-row bv-example-row-flex-cols"
  }, [_c('b-row', {
    staticClass: "justify-content-md-center textCentred"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align-v": "center"
    }
  }, [_c('h1', [_vm._v("HEADSHOT PHOTOGRAPHY")])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "text-center d-flex d-none"
  }, _vm._l((_vm.items3), function(item) {
    return _c('b-col', {
      key: item.id,
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "6",
        "lg": "6",
        "xl": "3",
        "align-v": "center"
      }
    }, [_c('div', {
      staticClass: "card-container"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "side"
    }, [_c('img', {
      directives: [{
        name: "img",
        rawName: "v-img:my-group",
        arg: "my-group"
      }],
      staticClass: "galleryItem",
      attrs: {
        "src": item.image,
        "alt": item.alt
      }
    })])])])])
  })), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "textLeft"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")]), _vm._v(" "), _c('p', {
    staticClass: "textLeft"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")])])], 1)], 1), _vm._v(" "), _c('b-container', {
    staticClass: "bv-example-row bv-example-row-flex-cols"
  }, [_c('b-row', {
    staticClass: "justify-content-md-center textCentred"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align-v": "center"
    }
  }, [_c('h1', [_vm._v("PORTRAIT PHOTOGRAPHY")])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "text-center d-flex d-none"
  }, _vm._l((_vm.items4), function(item) {
    return _c('b-col', {
      key: item.id,
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "6",
        "lg": "6",
        "xl": "3",
        "align-v": "center"
      }
    }, [_c('div', {
      staticClass: "card-container"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "side"
    }, [_c('img', {
      directives: [{
        name: "img",
        rawName: "v-img:my-group",
        arg: "my-group"
      }],
      staticClass: "galleryItem",
      attrs: {
        "src": item.image,
        "alt": item.alt
      }
    })])])])])
  })), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "textLeft"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")]), _vm._v(" "), _c('p', {
    staticClass: "textLeft"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")])])], 1)], 1)], 1)]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ced1acf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Service.vue
// module id = Prd+
// module chunks = 0